module.exports = __webpack_public_path__ + "img/path-7.84642cef.svg";